















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';
import {
  minLenght,
  hasAtLeastNumber,
  hasAtLeastLetter
} from '@/utils/validationPassword';
import { Faker } from '@/utils/faker';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import RulePassword from '@/componentsV2/molecules/RulePassword/RulePassword.vue';
import flagKeys from '@/constants/flagKeys';
import recaptchaRoutesKeys from '@/constants/recaptchaRoutesKeys';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

export type AccountFormData = {
  password: string;
};

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    Input,
    RulePassword,
    Typography
  }
})
export default class AccountForm extends Vue {
  failedRulesPassword: string[] = [];

  form: AccountFormData = {
    password: ''
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  clearFailedRulesPassword() {
    if (this.flagRulesPassword && this.$refs.observer) {
      this.failedRulesPassword = [];
    }

    this.$emit('changeUserDataPassword', this.form);

    return;
  }

  get isPasswordLengthValid() {
    return minLenght(this.form.password);
  }

  get isPasswordNumberValid() {
    return hasAtLeastNumber(this.form.password);
  }

  get isPasswordLetterValid() {
    return hasAtLeastLetter(this.form.password);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get flagRulesPassword() {
    return this.flags.includes(flagKeys.enableRulesPassword);
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (this.flagRulesPassword) {
      if (
        !this.isPasswordLengthValid ||
        !this.isPasswordNumberValid ||
        !this.isPasswordLetterValid
      ) {
        const failedRules = formRef.fields.password.failedRules;
        this.failedRulesPassword = Object.keys(failedRules);
        return null;
      }
    }

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    this.$emit('submit', this.form.password);

    if (formRef) formRef.reset();
  }

  created() {
    eventBus.$on('accountPasswordFormSubmit', this.onSubmit);

    segmentIo.page('Merchant Create Password');
  }

  beforeDestroy() {
    eventBus.$off('accountPasswordFormSubmit', this.onSubmit);
  }
}
